import React from 'react';
import { m } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { StarRating } from '../ui/StarRating';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
export function Hero() {
  return <header className="relative overflow-hidden bg-bg-primary pb-10 pt-8 sm:pb-12 sm:pt-10" data-id="element-116" data-mp="hvz4dzzy5igi">
      <div className="pointer-events-none absolute -top-40 left-1/2 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-lime/10 blur-3xl" aria-hidden="true" data-id="element-117" data-mp="mutwxtnpuldt" />
      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-4 text-center sm:px-6" data-id="element-118" data-mp="vmm0dkebou8w">
        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-119" data-mp="10lyo07d0q5cj">
          <SectionTag icon="⚽" data-id="element-120" data-mp="15lbdkzv9xqit">Para entrenadores que quieren dejar de improvisar</SectionTag>
        </m.div>

        <m.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="mt-5 font-heading text-4xl font-bold uppercase leading-[1.08] tracking-tight text-white sm:text-5xl md:text-6xl" data-id="element-121" data-mp="1ako8m7wau3wh">
          Todo tu año de <span className="text-lime" data-id="element-122" data-mp="3vvslp3vq8hj3">Fútbol</span> resuelto.
        </m.h1>

        {/* Plain img (no entrance animation): keeps paint instant once it downloads. */}
        <img src="https://cdn.magicpatterns.com/uploads/mfmCvTRZV6k4Vcdxb6hPSY/ChatGPT_Image_20_ago_2026__12_50_49__1_-removebg-preview.png" alt="MISTER PRO: La Pizarra del Entrenador — colección de 6 tomos y 5 bonos" width={640} height={620} loading="eager" fetchPriority="high" decoding="async" className="mt-8 w-full max-w-md sm:max-w-lg" data-id="element-123" data-mp="setv0axs5uvn" />

        <m.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.18
      }} className="mt-6 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-124" data-mp="1b5lazvc9wjj0">
          Ten siempre una sesión lista para llevar al campo, aunque sea domingo a las 10 de la noche y
          todavía no hayas preparado nada. MISTER PRO reúne 6 tomos y más de 150 sesiones reales{' '}
          <span className="font-semibold text-white" data-id="element-125" data-mp="2vuxina9js2wu">"Sesión en Mano"</span> para que abras el PDF, veas el
          ejercicio y sepas exactamente qué hacer en tu próximo entrenamiento.
        </m.p>

        <m.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.26
      }} className="mt-7 flex flex-col items-center" data-id="element-126" data-mp="2mu948eg8s0jf">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-127" data-mp="2cvteaesyaxbi">Quiero MISTER PRO por 19€</PrimaryButton>
          <p className="mt-3 text-xs text-muted sm:text-sm" data-id="element-128" data-mp="65n2ig67bwo9">
            ⚡ Acceso inmediato · 📱 Formato digital · Úsalo desde móvil, tablet u ordenador
          </p>
        </m.div>

        <m.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.34
      }} className="mt-6 flex flex-col items-center gap-2 text-sm text-muted sm:flex-row sm:gap-4" data-id="element-129" data-mp="1vmhaqi1l7emj">
          <div className="flex items-center gap-2" data-id="element-130" data-mp="25e4wc2bgq1g3">
            <StarRating data-id="element-131" data-mp="20llj56got8bt" />
            <span className="font-medium text-white" data-id="element-132" data-mp="20lbtjjzk136n">4,9/5</span>
            <span data-id="element-133" data-mp="2ecz1ih2v0059">· +500 reseñas verificadas</span>
          </div>
          <div className="hidden h-4 w-px bg-white/15 sm:block" aria-hidden="true" data-id="element-134" data-mp="2efl74b66w5ku" />
          <div className="flex items-center gap-1.5 text-lime" data-id="element-135" data-mp="2abn8s2oouysu">
            <FlameIcon size={16} className="fill-lime" data-id="element-136" data-mp="2obxxp06fu3bd" />
            <span data-id="element-137" data-mp="2o9bt99eug3xd">42 entrenadores eligieron MISTER PRO hoy</span>
          </div>
        </m.div>
      </div>
    </header>;
}